// https://comex.tw/quote-b-api/kline?token=e90c7f38f4be146af76d9d50b212b191-c-app&query=%7B%22trace%22:%226a788538-5590-44f5-bf2f-c7ec8633e169%22,%22data%22:%7B%22code%22:%22AUDUSD%22,%22kline_type%22:8,%22kline_timestamp_end%22:1744271559597,%22query_kline_num%22:2,%22adjust_type%22:0%7D%7D

import { apiGoldKlineData } from "@/api/acendex/gold";
import { createFetchClientGold } from "@/lib/fetch-tools-gold";
import { WSContext } from "@/router/router";
import { useSignal } from "@preact-signals/safe-react";
import dayjs from "dayjs";
import { useContext, useEffect, useMemo } from "react";
import { useMarketlistData } from "./use-marketlist-data";

export interface KlineParams {
  trace: string;
  data: KlineData;
}

export interface KlineData {
  code: string;
  kline_type: number;
  kline_timestamp_end: number;
  query_kline_num: number;
  adjust_type: number;
}

const apiToken = "e90c7f38f4be146af76d9d50b212b191-c-app";

function getQueryParams(params: KlineParams): { token: string; query: string } {
  return {
    token: apiToken,
    query: JSON.stringify(params),
  };
}
export function guid(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getRequestQuery(data: KlineData): KlineParams {
  return {
    trace: guid(),
    data: data,
  };
}

export const useGoldData = () => {
  const { data: ctmarketlistData } = useMarketlistData();

  const codeList = useMemo(() => {
    if (
      !ctmarketlistData ||
      !ctmarketlistData.data ||
      !ctmarketlistData.data.records
    )
      return [];
    return (
      ctmarketlistData.data?.records
        .filter((item) => item.coinType !== 1)
        .map((item) => item.coinname?.toUpperCase()) ?? []
    );
  }, [ctmarketlistData]);

  // amount: 404642.1396780678;
  // close: 14.0642;
  // count: 73332;
  // high: 14.2958;
  // id: 1744300800;
  // low: 13.2527;
  // open: 13.3691;
  // vol: 5625507.28761707;
  const [coinListData, setCoinListData] = useContext(WSContext);

  const { fetch } = createFetchClientGold(apiGoldKlineData);
  const data = useSignal<any>(null);

  useEffect(() => {
    const fn = () => {
      const time = dayjs().valueOf();
      for (const code of codeList) {
        fetch({
          fetchParams: getQueryParams(
            getRequestQuery({
              code,
              kline_type: 1,
              kline_timestamp_end: time,
              query_kline_num: 2,
              adjust_type: 0,
            })
          ),
        }).then((res) => {
          if (!res?.data) {
            return;
          }
          setCoinListData((prev) => ({
            ...prev,
            [code.toLowerCase()]: {
              close: res.data.kline_list.at(-1).close_price,
              high: res.data.kline_list.at(-1).high_price,
              low: res.data.kline_list.at(-1).low_price,
              open: res.data.kline_list.at(-1).open_price,
              vol: res.data.kline_list.at(-1).volume,
              id: res.data.kline_list.at(-1).timestamp,
            },
          }));
          //   data.value = res.data.kline_list.at(-1).close_price;
        });
      }
      timeoutId = setTimeout(fn, 3000);
    };
    
    let timeoutId: NodeJS.Timeout;
    if (codeList.length > 0) {
      fn();
    }
    
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [codeList]);

  return {
    data,
  };
};

export const fetchGoldKlineData = async (code: string, period: number) => {
  const calcPeriod = [
    1,
    1,
    1,
    2,
    3,
    4,
    5,
    8,
    9,
  ][period] ?? 1;
  
  const { fetch } = createFetchClientGold(apiGoldKlineData);
  const res = await fetch({
    fetchParams: getQueryParams(
      getRequestQuery({
        code,
        kline_type: calcPeriod,
        kline_timestamp_end: dayjs().valueOf(),
        query_kline_num: 300,
        adjust_type: 0,
      })
    ),
  });

  if (!res?.data) {
    return [];
  }

  const klineData = res.data.kline_list.map((item) => ({
    close: Number(item.close_price),
    high: Number(item.high_price),
    low: Number(item.low_price),
    open: Number(item.open_price),
    timestamp: Number(item.timestamp) * 1000,
    turnover: Number(item.turnover),
    volume: Number(item.volume),
  }));
  
  return klineData;
};
